module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_flow-04-c71a00cfc1882ac638840fcb40903981.png";